import { Component, OnInit } from '@angular/core';

import { ApContentService } from '@ap/content';

import { BaseErrorPageComponent } from '../base-error-page/base-error-page.component';

import content from './browser-error.content.json';

/**
 * @ngdoc component
 * @name NotFoundErrorPageComponent
 * @module MKErrorPageModule
 */
@Component({
    selector: 'browser-error-page',
    templateUrl: '../base-error-page/base-error-page.component.html',
    styleUrls: ['../base-error-page/error-page.component.scss'],
    standalone: false
})
export class BrowserErrorComponent extends BaseErrorPageComponent implements OnInit {
    public constructor(private readonly contentService: ApContentService) {
        super();
    }

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
        this.title = this.contentService.get('browser-error-page.title');
        this.message = this.contentService.get('browser-error-page.message');
        this.linkText = this.contentService.get('browser-error-page.link-text');
        this.link = this.contentService.get('browser-error-page.link');
    }
}
